var modal = {
  "adapter-loader.message": "Verifieer uw {{adapter}}-account om door te gaan",
  "adapter-loader.message1": "Verifieer uw {{adapter}}",
  "adapter-loader.message2": "account om door te gaan",
  "errors-invalid-number-email": "Ongeldig e-mailadres of telefoonnummer",
  "errors-required": "Vereist",
  "external.back": "Terug",
  "external.connect": "Verbinden met portemonnee",
  "external.title": "Externe portemonnee",
  "external.walletconnect-connect": "Verbinden",
  "external.walletconnect-copy": "Klik op de QR-code om te kopiëren naar het klembord",
  "external.walletconnect-subtitle": "Scan de QR-code met een WalletConnect-compatibele portemonnee",
  "footer.message": "Zelfbeheerde login door",
  "footer.message-new": "Zelf-custodial login via Web3Auth",
  "footer.policy": "Privacybeleid",
  "footer.terms": "Gebruiksvoorwaarden",
  "footer.terms-service": "Gebruiksvoorwaarden",
  "footer.version": "Versie",
  "header-subtitle": "Selecteer een van de volgende opties om door te gaan",
  "header-subtitle-name": "Uw {{appName}}-portemonnee met één klik",
  "header-subtitle-new": "Uw blockchain-portemonnee met één klik",
  "header-title": "Aanmelden",
  "header-tooltip-desc": "De portemonnee dient als een account om uw digitale activa op de blockchain op te slaan en te beheren.",
  "header-tooltip-title": "Portemonnee",
  "network.add-request": "Deze site vraagt om een netwerk toe te voegen",
  "network.cancel": "Annuleren",
  "network.from": "Van",
  "network.proceed": "Doorgaan",
  "network.switch-request": "Deze site vraagt om over te schakelen naar een ander netwerk",
  "network.to": "Naar",
  "popup.phone-body": "Uw landcode wordt automatisch gedetecteerd, maar als u een telefoonnummer uit een ander land gebruikt, moet u handmatig de juiste landcode invoeren.",
  "popup.phone-header": "Telefoonnummer en landcode",
  "social.continue": "Doorgaan met",
  "social.continueCustom": "Doorgaan met {{adapter}}",
  "social.email": "E-mail",
  "social.email-continue": "Doorgaan met e-mail",
  "social.email-new": "naam@voorbeeld.com",
  "social.passwordless-cta": "Doorgaan",
  "social.passwordless-title": "E-mail of telefoon",
  "social.phone": "Telefoon",
  "social.policy": "We slaan geen gegevens op die verband houden met uw sociale logins.",
  "social.sms": "Mobiel",
  "social.sms-continue": "Doorgaan met mobiel",
  "social.sms-invalid-number": "Ongeldig telefoonnummer",
  "social.sms-placeholder-text": "Bijv.:",
  "social.view-less": "Minder opties bekijken",
  "social.view-less-new": "Minder bekijken",
  "social.view-more": "Meer opties bekijken",
  "social.view-more-new": "Meer bekijken",
  "post-loading.connected": "U bent verbonden met uw account",
  "post-loading.something-wrong": "Er is iets fout gegaan!"
};
var dutch = {
  modal: modal
};

export { dutch as default, modal };
//# sourceMappingURL=dutch-PZr73RiR.js.map
